import {EntryIcon} from "@client/components/EntryIcon";
import {EYEBROW, JOY_GRADIENT} from "@client/components/styles";
import {ChevronDownIcon} from "@heroicons/react/16/solid";
import {classNames} from "@reactivated";
import React from "react";

// The page gradient as a fixed backdrop under a SimpleScene scroller, with
// the content lifted above it; the scene's `surface` paints the same top
// stop behind the header.
export const Gradient = ({children}: {children: React.ReactNode}) => (
    <>
        <div
            className="pointer-events-none fixed inset-0 z-0"
            style={{background: JOY_GRADIENT}}
        />
        {/* A column that fills the shell's content area, so a view can
            center in the space that is left under its cards. */}
        <div className="relative z-10 flex min-h-full flex-col">{children}</div>
    </>
);

// The scene name, small, for headers that also carry a control.
export const SceneTitle = ({children}: {children: React.ReactNode}) => (
    <span className="text-[17px] font-light tracking-[-0.01em] text-[oklch(0.18_0.02_280)]">
        {children}
    </span>
);

// The one chevron every select and listbox wears.
export const SelectChevron = ({className}: {className?: string}) => (
    <ChevronDownIcon
        aria-hidden="true"
        className={classNames("size-[18px] text-[oklch(0.5_0.03_280)]", className)}
    />
);

export const Eyebrow = ({
    children,
    className,
}: {
    children: React.ReactNode;
    className?: string;
}) => <div className={classNames(EYEBROW, className)}>{children}</div>;

// Title block: an optional picture beside the name, then a one-line note.
export const Headline = ({
    icon,
    name,
    note,
}: {
    icon?: React.ComponentProps<typeof EntryIcon>["icon"];
    name: string;
    note?: React.ReactNode;
}) => (
    <div>
        <div className="flex items-center gap-3.5">
            <EntryIcon icon={icon} size="headline" />
            <h2 className="text-[26px] leading-[1.2] font-light tracking-[-0.02em] text-[oklch(0.18_0.02_280)]">
                {name}
            </h2>
        </div>
        {note != null && (
            <div className="mt-[7px] text-[13.5px] font-light text-[oklch(0.5_0.03_280)]">
                {note}
            </div>
        )}
    </div>
);
